/* Copyright (c) 2025 curryfirm.com */

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// If you plan to use other Firebase services, import them here (e.g., getStorage, getFunctions).

const firebaseConfig = {
    apiKey: "AIzaSyBahUMw1l_khlw2_iIfWwQHhxoE4OnufKM",
    authDomain: "dumpster-route.firebaseapp.com",
    projectId: "dumpster-route",
    storageBucket: "dumpster-route.appspot.com",
    messagingSenderId: "744974743209",
    appId: "1:744974743209:web:6af80194f5b8b818101bb8",
    measurementId: "G-4N9C1T8W4P"
};

// Initialize Firebase app
const app = initializeApp(firebaseConfig);

// Export initialized Firebase features for use throughout your app
export const auth = getAuth(app);
export const db = getFirestore(app);